import { render, staticRenderFns } from "./SplashModal.vue?vue&type=template&id=0ba761fa&scoped=true&"
import script from "./SplashModal.vue?vue&type=script&lang=js&"
export * from "./SplashModal.vue?vue&type=script&lang=js&"
import style0 from "./SplashModal.vue?vue&type=style&index=0&id=0ba761fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba761fa",
  null
  
)

export default component.exports